import React from 'react'
import { Button, Form, Space } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
import Access from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestInputs = ({ initialValue = [''] }) => {
    return (
        <Access
            permissions={[AssignmentPermissions.CAN_EDIT]}
            fallback={<Text>{initialValue.join(', ')}</Text>}
        >
            <Form.List
                name='inputs'
                rules={[
                    {
                        validator: async (_, inputs) => {
                            if (!inputs || inputs.length < 1) {
                                return Promise.reject(new Error('At least 1 input'))
                            }
                        },
                    },
                ]}
                initialValue={initialValue}
            >
                {(fields, { add, remove }, { errors }) => {
                    return (
                        <>
                            {fields.map((field, index) => {
                                return (
                                    <Form.Item label={index === 0 ? 'Inputs' : ''} required={false} key={field.key}>
                                        <Space.Compact block>
                                            <Form.Item
                                                {...field}
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: 'Please enter the input or delete this field',
                                                    },
                                                ]}
                                                className='f-width'
                                            >
                                                <TextArea placeholder='Input' autoSize={{ minRows: 1, maxRows: 4 }} />
                                            </Form.Item>
                                            {fields.length > 1 ? (
                                                <Button
                                                    icon={<MinusCircleOutlined />}
                                                    aria-label='remove input'
                                                    onClick={() => remove(field.name)}
                                                />
                                            ) : null}
                                        </Space.Compact>
                                    </Form.Item>
                                )
                            })}
                            <Form.Item>
                                <Button type='dashed' onClick={() => add()} icon={<PlusOutlined />} block>
                                    Add input
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>
                    )
                }}
            </Form.List>
        </Access>
    )
}

export default TestInputs
